import React from "react";

import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Global error handler for external scripts
window.addEventListener('error', (event) => {
  if (event.message && event.message.includes('SLSettings')) {
    console.warn('External script error suppressed:', event.message);
    event.preventDefault();
    return false;
  }
});

// Handle unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.message && event.reason.message.includes('SLSettings')) {
    console.warn('External script promise rejection suppressed:', event.reason.message);
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
